import * as React from "react";
import { ATCCodeModel } from "../../../models/atcCode";
import AtcCodesView from './atcCodesView';
import ATCCodeService from '../../../services/atcCodeService';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import Loadable from 'react-loadable';
import AtcCodeAddEditDialog from './atcCodeAddEditDialog';
import { TreeNodeModel } from '../../../models/treeNodeModel';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { ContextMenu } from 'primereact/contextmenu';
import { AtcCodeContentModel } from '../../../models/atcCode/atcCodeContentModel';
import { Lang } from '../../../common/enums';
import * as HelperFunctions from '../../../common/functions/helperFunctions';

/*const MedicineAddEditLoadable = Loadable({
	loader: () => import('./atcCodesAddEditDialog'),
	loading: Spinner,
	delay: 1000, // 0.1 seconds
	timeout: 10000, // 10 seconds
});*/

interface IProps {
}

interface IState {
  listAtcCodes: Array<ATCCodeModel>;
  treeAtcCodes: Array<TreeNodeModel>;
  isLoading: boolean;
  error: any;
  validationMessage: string;
  isVisibleDialog: boolean;
  isVisibleDialogWrap: boolean;
  isVisibleConfirmDialog: boolean;
  currentATCCode: ATCCodeModel;
  selectionKeys: any;
  selectedAtcCodeIds: Array<number>;
  contextMenu: any;
}

class AtcCodesContainer extends React.Component<IProps, IState> {
  atcCodeService = new ATCCodeService();
  messages: any;
  growl: any;
  cm: any;

  constructor(props: IProps) {
    super(props);

    const menu = [
      // {
      //   label: 'Root',
      //   icon: 'pi pi-plus',
      //   command: () => { this.handleAddClick(null, 'root') }
      // },
      // {
      //   label: 'Sibling',
      //   icon: 'pi pi-plus',
      //   command: () => { this.handleAddClick(this.state.selectedAtcCodeIds[0], 'sibling') }
      // },
      {
        label: 'Child',
        icon: 'pi pi-plus',
        command: () => { this.handleAddClick(this.state.selectedAtcCodeIds[0], 'child') }
      },
      {
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => { this.handleEditClick(this.state.selectedAtcCodeIds[0]) }
      },
      {
        label: 'Delete',
        icon: 'pi pi-trash',
        command: () => { this.handleDeleteClick() }
      }
    ];

    this.state = {
      error: null,
      validationMessage: '',
      listAtcCodes: new Array<ATCCodeModel>(0),
      treeAtcCodes: new Array<TreeNodeModel>(0),
      isLoading: false,
      isVisibleDialog: false,
      isVisibleDialogWrap: false,
      isVisibleConfirmDialog: false,
      currentATCCode: new ATCCodeModel(),
      selectionKeys: null,
      selectedAtcCodeIds: new Array<number>(0),
      contextMenu: menu
    };
  }

  // events
  componentDidMount() {
    this.getAllATCCodes();
  }

  // handles
  handleAddClick = (parentId, type) => {
    var parent = this.state.listAtcCodes.find(f => f.atcCodeId == parentId);
    let parentLevelNo = parent ? parent.levelNo : 0;
    let parentParentID = parent ? parent.parentId : 0;
    let newAtcCode = new ATCCodeModel();
    newAtcCode.parentId = type == 'sibling' ? parentParentID : parentId;
    newAtcCode.levelNo = (type == 'child' ? parentLevelNo + 1 : parentLevelNo);
    let contentList = new Array<AtcCodeContentModel>(0);
    const langKeys = HelperFunctions.getEnumKeys(Lang);

    langKeys.map(k => {
      let content = new AtcCodeContentModel();
      content.langId = parseInt(Lang[k]);
      content.atcCodeName = '';
      contentList.push(content);
    });

    newAtcCode.atcCodeContent = contentList;
    this.setcurrentATCCode(newAtcCode);
    this.showEditDialog(true);
  };

  handleEditClick = id => {
    this.setState({
      isLoading: true
    });
    this.atcCodeService.getAtcCode(id)
      .then(
        (data: ATCCodeModel) => {
          this.setcurrentATCCode(data);
          this.showEditDialog(true);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        }
      );
  };

  handleDeleteClick = () => {
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteAtcCode(id: number) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.atcCodeService.deleteAtcCode(id)
      .then(
        data => {
          this.getAllATCCodes();
          this.setState({
            isLoading: false,
            selectionKeys: null,
            selectedAtcCodeIds: new Array<number>(0)
          });
          this.growl.show({ severity: 'success', detail: 'You have successfully deleted an ATC code.' });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleSelectionChange = (value) => {
    let atcCodeIds = new Array<number>(0);
    if (this.state.selectedAtcCodeIds.some(v => v == value)) {
      value = null;
      atcCodeIds = new Array<number>(0);
    } else {
      atcCodeIds.push(+value);
    }
    //atcCodeIds = this.setSelectedATCCodesIds(Object.keys(value)); // for multiple selection
    this.setState({
      selectionKeys: value,
      selectedAtcCodeIds: atcCodeIds.slice()
    });
  }

  // setSelectedATCCodesIds = (keys: Array<string>) => {
  //   let newArray = Array<number>(0);
  //   if (keys) {
  //     keys.map(key => {
  //       newArray.push(+key);
  //     });
  //   }
  //   return newArray;
  // }

  handleSaveButton = (currentATCCode: ATCCodeModel) => {
    this.setState({
      isLoading: true
    });

    if (!currentATCCode.atcCodeId) { // Add
      this.atcCodeService.addAtcCode(currentATCCode)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentATCCode(new ATCCodeModel());
            this.getAllATCCodes();
            this.setState({
              isLoading: false
            });
            this.growl.show({ severity: 'success', detail: 'You have successfully created an ATC code.' });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentATCCode(new ATCCodeModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          }
        );
    } else { // Edit
      this.atcCodeService.editAtcCode(currentATCCode.atcCodeId, currentATCCode)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentATCCode(new ATCCodeModel());
            this.getAllATCCodes();
            this.setState({
              isLoading: false
            });
            this.growl.show({ severity: 'success', detail: 'You have successfully updated an ATC code.' });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentATCCode(new ATCCodeModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          });
    }
  };

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  // methods
  getAllATCCodes() {
    this.setState({
      isLoading: true
    });

    this.atcCodeService.getAllAtcCodes().then(
      (data: Array<ATCCodeModel>) => {
        this.setState({
          isLoading: false,
          listAtcCodes: data
        });
        this.createTree();
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  createTree() {
    let subTree = this.createSubTree(null);
    this.setState({
      treeAtcCodes: subTree
    });
  }

  createSubTree(parentId) {
    let subTree = new Array<TreeNodeModel>(0);

    this.state.listAtcCodes
      .filter(f => parentId ? f.parentId == parentId : f.parentId == null)
      .sort((a, b) => (a.orderNo > b.orderNo) ? 1 : (b.orderNo > a.orderNo ? -1 : 0))
      .map(f => {
        let node = new TreeNodeModel();
        node.key = f.atcCodeId.toString();
        node.label = f.atcCode + ' - ' + (f.atcCodeContent && f.atcCodeContent.length > 0 ? f.atcCodeContent[0].atcCodeName + ' / ' : '')
          + (f.atcCodeContent && f.atcCodeContent.length > 1 ? f.atcCodeContent[1].atcCodeName : '');
        node.data = { ...f };
        //node.icon = "pi pi-fw pi-circle-on";
        if (this.state.listAtcCodes.some(a => a.parentId == f.atcCodeId)) {
          node.children = this.createSubTree(f.atcCodeId);
        };
        subTree.push(node);
      });

    return subTree;
  }

  setcurrentATCCode(activeIngredient: ATCCodeModel) {
    this.setState({ currentATCCode: { ...activeIngredient } });
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleDialogWrap: show,
      validationMessage: ''
    });
    setTimeout(() => this.setState({
      isVisibleDialog: show
    }));
  };

  getSelectedAtcCodeNames = () => {
    let atcCodes = new Array<string>(0);
    this.state.listAtcCodes.filter(a => this.state.selectedAtcCodeIds
      .some(b => b == a.atcCodeId))
      .map(a => atcCodes.push(a.atcCode));
    return atcCodes.join(', ');
  }

  handleSynchClick = () => {
    this.setState({
      isLoading: true
    });
    this.atcCodeService.syncAtcCodes()
      .then(
        (data) => {
          this.growl.show({ severity: 'success', detail: 'You have successfully sync ATC codes.' });
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        }
      );
  }

  // render
  public render() {

    const { treeAtcCodes, isLoading, error, selectionKeys, selectedAtcCodeIds } = this.state;
    const atcNamesForDelete = this.getSelectedAtcCodeNames();

    return (
      <div>

        <h3>ATC Codes</h3>

        {isLoading ? <Spinner /> : null}

        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

        <Growl ref={(el) => this.growl = el} />

        {this.state.isVisibleDialogWrap ? (
          <AtcCodeAddEditDialog
            saveClick={this.handleSaveButton}
            cancelClick={this.handleCancelButton}
            currentATCCode={this.state.currentATCCode}
            isVisible={this.state.isVisibleDialog}
          />
        ) : null}

        <div className="mb-2">
          <Button
            onClick={() => this.handleAddClick(null, 'root')}
            icon="pi pi-plus"
            className="p-button-success"
            style={{ marginRight: "5px" }}
            label="Root"
            tooltipOptions={{ position: 'top' }} />
          {/* <Button
            onClick={() => this.handleAddClick(selectedAtcCodeIds[0], 'sibling')}
            icon="pi pi-plus"
            className="p-button-success"
            style={{ marginRight: "5px" }}
            label="Sibling"
            tooltipOptions={{ position: 'top' }}
            disabled={!(selectedAtcCodeIds && selectedAtcCodeIds.length == 1)}
          /> */}
          <Button
            onClick={() => this.handleAddClick(selectedAtcCodeIds[0], 'child')}
            icon="pi pi-plus"
            className="p-button-success"
            style={{ marginRight: "5px" }}
            label="Child"
            tooltipOptions={{ position: 'top' }}
            disabled={!(selectedAtcCodeIds && selectedAtcCodeIds.length == 1)}
          />
          <Button
            onClick={() => this.handleEditClick(selectedAtcCodeIds[0])}
            icon="pi pi-pencil"
            className="p-button-warning"
            style={{ marginRight: "5px" }}
            label="Edit"
            tooltipOptions={{ position: 'top' }}
            disabled={!(selectedAtcCodeIds && selectedAtcCodeIds.length == 1)}
          />
          <Button
            onClick={() => this.handleDeleteClick()}
            icon="pi pi-trash"
            className="p-button-danger"
            style={{ marginRight: "5px" }}
            label="Delete"
            tooltipOptions={{ position: 'top' }}
            disabled={!(selectedAtcCodeIds && selectedAtcCodeIds.length > 0)}
          />
          <Button
            onClick={() => this.handleSynchClick()}
            icon="pi pi-refresh"
            className="p-button-success"
            style={{ marginRight: "5px" }}
            label="Synchronize"
            tooltipOptions={{ position: 'top' }}
          />
        </div>

        <ContextMenu model={this.state.contextMenu} ref={el => this.cm = el} />

        <AtcCodesView
          treeAtcCodes={treeAtcCodes}
          handleSelectionChange={this.handleSelectionChange}
          selectionKeys={selectionKeys}
          onContextMenu={event => (selectedAtcCodeIds && selectedAtcCodeIds.length > 0 ? this.cm.show(event.originalEvent) : null)}
        />

        <ConfirmDialog
          headerTitle="Confirm Dialog"
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteAtcCode(this.state.selectedAtcCodeIds[0]) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          Are you sure that you want to delete "{atcNamesForDelete}" and all its children?
        </ConfirmDialog>
      </div>
    );
  }
}

export default AtcCodesContainer;